<template>
  <h5 class="fw-light mb-2">Anexos:</h5>
  <p class="fw-bold mb-2">XML:</p>
  <div v-if="measure.xml">
    <textarea class="form-control" rows="3" v-model="xmlContent" disabled />
    <div class="text-end mt-3">
      <button
        class="btn btn-info rounded-pill"
        title="Fazer Download em Formato JSON"
        @click="createAndOpenJSON"
      >
        Fazer Download em Formato JSON
      </button>
      <button
        class="btn btn-secondary rounded-pill ms-2"
        title="Fazer Download do XML"
        @click="createAndOpenXML"
      >
        Fazer Download do XML
      </button>
    </div>
  </div>
  <div v-else>
    <p>
      <strong>Justificativa do não envio: </strong>
      {{ measure.xmlJustify }}
    </p>
  </div>
  <hr />
  <p class="fw-bold mb-2">Nota / Outros Arquivos:</p>
  <div v-if="measure.attachs.length > 0">
    <template v-for="attach in measure.attachs" :key="attach.id">
      <iframe
        v-if="verifyIsPDF(attach.file)"
        :src="`${pathFile}/${attach.measureId}/${attach.file}`"
        class="pdf-content"
        frameborder="0"
      />
      <div class="text-end mt-2 mb-3">
        <a
          :href="`${pathFile}/${attach.measureId}/${attach.file}`"
          class="btn btn-secondary rounded-pill"
          title="Download"
          target="_blank"
          download
        >
          Fazer download do {{ attach.file }}
        </a>
      </div>
    </template>
  </div>
  <p v-else>Nenhum arquivo encontrado</p>
  <hr />
  <h5 class="fw-light mb-2">Outras Informações:</h5>
  <p>
    <strong>Data de Vencimento: </strong>
    {{
      measure.dueDate ? dateTimeSqlToDateBR(measure.dueDate) : 'Não informado'
    }}
  </p>
  <p>
    <strong>Data de Pagamento: </strong>
    {{
      measure.paymentDate
        ? dateTimeSqlToDateBR(measure.paymentDate)
        : 'Não informado'
    }}
  </p>
  <p v-if="measure.reprovationJustify" class="mb-0">
    <strong>Justificativa da Reprovação: </strong>
    {{ measure.reprovationJustify }}
  </p>
</template>

<script>
import { dateTimeSqlToDateBR } from '@/utils/date'

export default {
  name: 'AttachsMeasure',

  props: {
    measure: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      xmlContent: this.measure.xml,
      pathFile: '',
      dateTimeSqlToDateBR,
    }
  },

  methods: {
    createAndOpenJSON() {
      const blob = new Blob([this.measure.jsonFile], { type: 'text/json' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'dados_nota.json'
      link.click()
      link.remove()
    },

    createAndOpenXML() {
      const blob = new Blob([this.measure.xml], { type: 'text/xml' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'nota.xml'
      link.click()
      link.remove()
    },

    verifyIsPDF(file) {
      return file.split('.').pop() === 'pdf'
    },
  },

  mounted() {
    if (this.measure.type === 'Contrato') {
      this.pathFile = `${process.env.VUE_APP_BASE_URL_API}/uploads/contracts/${this.measure.contractId}/measures`
    } else {
      this.pathFile = `${process.env.VUE_APP_BASE_URL_API}/uploads/requests_new/${this.measure.idmov}/measures`
    }
  },
}
</script>

<style scoped>
.pdf-content {
  height: 300px;
  width: 100%;
  overflow-y: scroll;
}
</style>
